import {
    TOGGLE_SIDEBAR
} from "../actions/general";

const initialState = {
    toggle_sidebar_state: false
};

export default function general(state = initialState, action){
    switch (action.type){
        case TOGGLE_SIDEBAR:
            return {
                ...state,
                toggle_sidebar_state: action.open
            };
        default:
            return initialState;
    }
}